import { createContext } from 'react';

export type ModalContextValue = {
  openModal?: (modalType: string, modalProps: any) => () => void;
};

const ModalContext = createContext<ModalContextValue>({});

export default ModalContext;
